import TimeFilter from "./TimeFilter";
import { useControl } from "../control/ControlContext";

export default function FilterControls() {
  const { grainOverride, setGrainOverride, timeRange } = useControl();

  const autoGrain = (() => {
    if (!timeRange.start || !timeRange.end) return "day";
    const diffDays = (timeRange.end.getTime() - timeRange.start.getTime()) / (1000 * 60 * 60 * 24);
    return diffDays > 63 ? "week" : "day";
  })();

  const resolvedGrain = grainOverride ?? autoGrain;

  return (
    <div className="filter-controls">
      <div className="logo-container">
        <svg
          viewBox="0 0 2292 2292"
          xmlns="http://www.w3.org/2000/svg"
          fill="currentColor"
          width="40"
          height="40"
          aria-hidden
        >
          <circle fill="#d2c8ff" cx="1145.5" cy="1146" r="1146" />
          <path d="M840.3,599.7c-127.5,0-199.8,56.8-236,175.7v.6H466.5v930h137.8v-620.5c0-205,50-363.5,225.7-363.5h246.8v984h137.8v-706.6c0-168.8,106.8-287.7,255-287.7s217.1,99.9,217.1,248.1v746.2h137.8v-768.6c0-211.9-127.5-351.5-323.9-351.5s-241.2,60.3-286,180.9h-5.9v-167.1h-368.4Z" />
        </svg>
        <span className="dashboard-title">WPR Dashboard</span>
      </div>
      {/* Field filtering hidden until changed to filter the data loaded for the plots by 1D dimension
          To restore: import FieldFilter from "./FieldFilter" and add <FieldFilter /> here */}
      <TimeFilter />
      <div className="grain-toggle">
        <button
          type="button"
          className={`grain-toggle__btn ${resolvedGrain === "day" ? "grain-toggle__btn--active" : ""}`}
          onClick={() => setGrainOverride(grainOverride === "day" ? null : "day")}
          aria-pressed={resolvedGrain === "day"}
        >
          Day
        </button>
        <button
          type="button"
          className={`grain-toggle__btn ${resolvedGrain === "week" ? "grain-toggle__btn--active" : ""}`}
          onClick={() => setGrainOverride(grainOverride === "week" ? null : "week")}
          aria-pressed={resolvedGrain === "week"}
        >
          Week
        </button>
      </div>
    </div>
  );
}
